import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BaseFacet from '../../../../../../classes/facets/BaseFacet/BaseFacet';
import searchFilterPropType from '../../../../../../utility/PropTypes/searchFilterPropType';

function FilterModalPatternG({
  facetType,
  facetClass,
  facets,
  setFacets,
  clearFacets,
}) {
  const operatorOptions = facetClass.getOperatorSelectOptions();
  const valueOptions = facetClass.getValueSelectOptions();

  const [selectedOperator, setSelectedOperator] = useState(
    operatorOptions[0].value,
  );
  const [selectedValue, setSelectedValue] = useState('');

  const handleOperatorChange = (e) => {
    const operatorId = Number(e.target.value);
    setSelectedOperator(operatorId);

    if (facets.length === 1) {
      setFacets([
        {
          ...facets[0],
          operatorId,
        },
      ]);
    }
  };

  const handleValueChange = (e) => {
    const { value } = e.target;

    setSelectedValue(value);

    if (value === '') {
      clearFacets();
      return;
    }

    setFacets([
      {
        facetId: facetType.id,
        operatorId: Number(selectedOperator),
        value1: value.toString(),
        value2: '',
      },
    ]);
  };

  useLayoutEffect(() => {
    if (facets.length === 1) {
      setSelectedOperator(facets[0].operatorId);
      setSelectedValue(facets[0].value1);
    }
  }, []);

  return (
    <div>
      <h6>
        {facetClass.getDisplayName()}
        {' '}
        {facetClass.getDescription()}
      </h6>

      {/* Operator */}
      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            <select
              className="form-control"
              data-testid="operator-combobox"
              value={selectedOperator}
              onChange={handleOperatorChange}
            >
              {operatorOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="offset-sm-2 col-sm-8">
          <div className="form-group">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="sr-only" htmlFor="facetValue">
              Alert Count
            </label>
            <input
              id="facetValue"
              data-testid="numeric-input"
              type="number"
              className="form-control"
              min={1}
              max={valueOptions.length}
              value={selectedValue}
              onChange={handleValueChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

FilterModalPatternG.propTypes = {
  facetType: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  facetClass: PropTypes.instanceOf(BaseFacet).isRequired,
  facets: PropTypes.arrayOf(
    PropTypes.shape(searchFilterPropType),
  ).isRequired,
  setFacets: PropTypes.func.isRequired,
  clearFacets: PropTypes.func.isRequired,
};

export default FilterModalPatternG;
